import ve from "../../../../assets/images/productos/ve/VE.png";
import qr from "../../../../assets/images/QR Fabian Llamazares.svg";
import Producto from "../../../../components/producto";

import { useTranslation } from "react-i18next";

function VE() {

  const {t} = useTranslation();

  return (
    <Producto
      fotos={[]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "17,5 / 38"],
        [t("tensionDeImpulso"), "kV", "95 / 170"],
        [
          t("corrienteNominal"),
          "A",
          "630 / 800 / 1.250 / 2.000 / 2.500 / 3.150",
        ],
        [t("corrienteInterrupcionNominal"), "kA", "25 / 31,5 / 40"],
        [t("capacidadDeCierreNominal"), "kA", "63 / 80 / 100"],
        [t("tensionSoportada"), "kV", "80"],
        [t("frecuenciaNominal"), "Hz", "50 / 60"],
      ]}
      datosTabla2={[
        ["VE 36", "A", "1.250 / 3.150", "2.500"],
        [t("ancho"), "mm", "540", "860"],
        [t("alto"), "mm", "495 / 670", "1.700"],
        [t("profundidad"), "mm", "550 / 660", "860"],
      ]}
      nombreProducto={"VE"}
      fotoProducto={ve}
      descripcionProducto={t("ve.titulo_descripcion")}
      caracteristicas={[t("ve.bullet1"), t("ve.bullet2"), t("ve.bullet3")]}
      vendedor={{
        nombre: "Fabian Llamazares",
        telefono: "+54 9 11 5096-3680",
        mail: "fllamazares@ema.com.ar",
        qr: qr,
      }}
    />
  );
}

export default VE;
